// FILE: src/components/help/GlossaryDrawer.jsx
// Glossary button for the top bar: opens the glossary in a side panel on any
// page, including over a lesson, so students never lose their place (MTO 18.1).
import React, { useState } from "react";
import { Box, Button, Drawer, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import CloseIcon from "@mui/icons-material/Close";
import Glossary from "./Glossary";

export default function GlossaryDrawer({ compact = false }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      {compact ? (
        <Tooltip title="Glossary">
          <IconButton aria-label="Open the glossary" onClick={() => setOpen(true)} data-testid="glossary-button">
            <MenuBookOutlinedIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Button color="inherit" startIcon={<MenuBookOutlinedIcon />} onClick={() => setOpen(true)} data-testid="glossary-button">
          Glossary
        </Button>
      )}
      <Drawer
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
        slotProps={{ paper: { sx: { width: { xs: "100%", sm: 440 } }, role: "dialog", "aria-labelledby": "glossary-drawer-title" } }}
      >
        <Box sx={{ p: 3 }}>
          <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between", mb: 2 }}>
            <Typography id="glossary-drawer-title" variant="h2" component="h2">
              Glossary
            </Typography>
            <IconButton aria-label="Close the glossary" onClick={() => setOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Stack>
          {open && <Glossary headingLevel={3} dense autoFocus />}
        </Box>
      </Drawer>
    </>
  );
}
